import { IcoWarning24 } from '@onefootprint/icons';
import { getErrorMessage } from '@onefootprint/request';
import { Button, LoadingSpinner } from '@onefootprint/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Logger } from '@/idv/utils';
import useSubmitDocType from '../../../hooks/use-submit-doc-type';
import { isMobileKind } from '../../../utils/capture';
import { useNonIdDocMachine } from '../../components/machine-provider';
import type { NonIdDocKinds } from '../../types';
import requestKindToDocType from '../../utils/request-kind-to-doc-type';
const Init = () => {
  const {
    t
  } = useTranslation('idv', {
    keyPrefix: 'document-flow.non-id-doc.pages.init'
  });
  const [state, send] = useNonIdDocMachine();
  const {
    authToken,
    device,
    requirement
  } = state.context;
  const submitDocTypeMutation = useSubmitDocType();
  const {
    isError
  } = submitDocTypeMutation;
  const [numRetries, setNumRetries] = useState(0);
  const retryLimitExceeded = numRetries >= 3;
  useEffect(() => {
    submitDocTypeMutation.mutate({
      authToken,
      documentType: requestKindToDocType[requirement.config.kind as NonIdDocKinds],
      requestId: requirement.documentRequestId,
      deviceType: isMobileKind(device.type) ? 'mobile' : 'desktop'
    }, {
      onSuccess: data => {
        send({
          type: 'contextInitialized',
          payload: {
            id: data.id
          }
        });
      },
      onError: err => {
        const errorMsg = getErrorMessage(err);
        Logger.error(`Failed to submit non id-doc document type ${requirement.config.kind}. Error: ${errorMsg}`, {
          location: 'id-doc-country-and-type-container'
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numRetries]);
  const handleRetry = () => {
    setNumRetries(prev => prev + 1);
  };
  if (isError) {
    return <div className="flex h-full flex-col justify-center items-center gap-4 py-4 px-6">
        <div className="flex flex-col items-center justify-center gap-2">
          <IcoWarning24 color="error" />
          {retryLimitExceeded ? <div className="text-body-2 text-secondary text-center">{t($ => $['retry-limit-exceeded'])}</div> : <div className="text-body-2 text-secondary text-center">{t($ => $.error)}</div>}
        </div>
        {!retryLimitExceeded && <Button onClick={handleRetry}>{t($ => $['try-again'])}</Button>}
      </div>;
  }
  return <div className="flex flex-col items-center h-full min-h-[var(--loading-container-min-height)] justify-center text-center">
      <LoadingSpinner size="xlarge" />
    </div>;
};
export default Init;